// Lightweight event bus so wellness tools can notify the calendar
// (and any other consumers of useWellnessMonthLog) to refresh
// immediately after a write.

type Listener = () => void;

const listeners = new Set<Listener>();

export function notifyWellnessLogChanged() {
  listeners.forEach((l) => {
    try {
      l();
    } catch {
      /* noop */
    }
  });
}

export function subscribeWellnessLog(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
